export default "__VITE_ASSET__pW7Erj4C__"